import axios, { AxiosInstance, AxiosRequestConfig, InternalAxiosRequestConfig } from 'axios';

const getToken = () => {
  // try common storage keys
  return (
    localStorage.getItem('token') ||
    localStorage.getItem('accessToken') ||
    localStorage.getItem('auth_token') ||
    null
  );
};

const baseURL = process.env.REACT_APP_API_URL || '';

const api: AxiosInstance = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Attach token on each request if available
api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  try {
    const token = getToken();
    if (token && config && config.headers) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
  } catch (err) {
    // ignore
  }
  return config;
});

export type ApiRequestOptions = AxiosRequestConfig;

export async function request<T = any>(opts: ApiRequestOptions) {
  const res = await api.request<T>(opts);
  return res.data;
}

export default api;
